import "friendly-challenge/widget";

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

require('./modules/contact_form');
require('./overrides');
require('./overrides/fast-product-entry');
require('./request-cart');
require('./product');
require('./components/read-more');

const element = document.getElementById("sticky-main-bar");

$(document).ready(function () {
     initToasts();
})

function initToasts() {
    $('div#cartNotEmptyToast').toast('show');
}

$('#miniCartBody').on('DOMSubtreeModified', function () {
    var context = $(this);
    $('.row', context).each(function () {
        var row = $(this);
        $('.col-md-4', row).removeClass('col-md-4').addClass('col-md-6');

        $('.is-number-input > input', row).each(function () {
            var value = $(this).val();
            var parent = $(this).parent().parent();
            parent.remove();
            console.log(parent);
            //parent.html(value);
            console.log('onetime?');

            var new_element = $('<div class="col-4 col-sm-3 col-md-1 text-end" />');
            new_element.html(value + '&nbsp;x');

            $('.is-mini-cart-item__image-wrap', row).after(new_element);

        });

        var product_id = $('form > input.id', row).val();
        $('h4', row).each(function () {
            if ($(this)[0].parentNode.nodeName == 'DIV') {
                var product_url = window.config.urls.products.info.replace('info/#####', product_id);
                $(this).wrap('<a href="' + product_url + '" />');
            }
        });
        //
    });
});

$('.is-nav-not-clickable').click(function(){
    if($('body.is-mobile-active').length == 0) {
        return false;
    }
});

$(document).ready(function(){
    if($('body.is-mobile-active').length != 0) {
        $('html').css('overflow-x','hidden');
    }
})


